module.exports = __webpack_public_path__ + "img/carIcon.b4d3179f.png";